import classNames, { Argument } from 'classnames'
import React, { ReactNode } from 'react'

import IconTooltip from './icons/IconTooltip'
import Tooltip from './Tooltip'

import './Dropdown.scss'

export interface SelectOption<T> {
  label: string
  value: T | null
}

export interface DropdownProps<T extends string> {
  className?: Argument
  disabled?: boolean
  tooltip?: ReactNode
  label?: string
  selectId?: string
  onChange: (value: T | null) => void
  options: SelectOption<T>[]
  value?: T | null
}

const Dropdown = <T extends string>({
  className,
  disabled,
  tooltip,
  label,
  selectId,
  onChange,
  options,
  value,
  ...props
}: DropdownProps<T>) => {
  const isEmpty = !options.some(opt => opt.value === value)

  return (
    <div className={classNames('dropdown', className)}>
      <div className="dropdown__inputWrapper">
        <select
          disabled={disabled}
          aria-label={label}
          id={selectId}
          className={classNames('dropdown__input', {
            'dropdown__input--disabled': disabled,
            'dropdown__input--empty': isEmpty,
          })}
          onChange={e => onChange(e.target.value as T)}
          value={value ?? ''}
          {...props}
        >
          {options.map(opt => (
            <option key={opt.value} value={opt.value ?? ''}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      {tooltip && (
        <Tooltip label={tooltip} className="dropdown__tooltipWrapper">
          <IconTooltip width="24" height="24" />
        </Tooltip>
      )}
    </div>
  )
}

export default Dropdown
